import type { FC } from 'react';
import { Grid, Typography, Box, ImageList, ImageListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Loader from '@/shared/components/Loader';
import PlatformIcon from './PlatformIcon';
import type { IMediaLibraryImageModel } from '@/shared/models/media-library/media-library-image.model';

interface IImageSelectionGridProps {
  imageData: IMediaLibraryImageModel[];
  imageDataLoading: boolean;
  selected: IMediaLibraryImageModel[];
  isSelected: (image: any) => boolean;
  onToggleSelect: (image: any) => void;
  platform: string;
}

const ImageSelectionGrid: FC<IImageSelectionGridProps> = ({
  imageData,
  imageDataLoading,
  selected,
  isSelected,
  onToggleSelect,
  platform,
}) => {
  const { t } = useTranslation();

  if (imageDataLoading) {
    return <Loader />;
  }

  return (
    <Grid>
      <Typography variant="h6" sx={{ pl: 1 }}>
        Please select 4 media files to proceed ({selected.length}/4 {t('selected')})
      </Typography>
      <Box sx={{ p: 1 }}>
        {imageData && (
          <ImageList variant="masonry" cols={4} gap={8}>
            {imageData.map((image: any, key: number) => (
              <ImageListItem
                key={key}
                sx={{
                  cursor: 'pointer',
                  border: isSelected(image) ? '5px solid #000' : '5px solid transparent',
                  overflow: 'hidden',
                  position: 'relative',
                }}
                onClick={() => onToggleSelect(image)}>
                <img
                  src={image.preSignedUrl}
                  width="100%"
                  style={{ borderRadius: '5px', opacity: isSelected(image) ? 0.25 : 1 }}
                  alt={image.fileName}
                />
                {isSelected(image) && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '0',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <PlatformIcon platform={platform} />
                  </Box>
                )}
              </ImageListItem>
            ))}
          </ImageList>
        )}
      </Box>
    </Grid>
  );
};

export default ImageSelectionGrid;
